import React from 'react';
import { Navbar as BSNavbar, Nav, Container, Dropdown } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useClientAuth } from '../context/ClientAuthContext';

const ClientNavbar = () => {
  const { portalClient, clientLogout } = useClientAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    clientLogout();
    navigate('/client');
  };

  return (
    <BSNavbar bg="primary" variant="dark" expand="lg" className="shadow-sm">
      <Container fluid>
        <BSNavbar.Brand
          onClick={() => navigate('/client/dashboard')}
          style={{ cursor: 'pointer' }}
          className="fw-bold"
        >
          <i className="fas fa-file-invoice me-2"></i>
          Certificate Portal
        </BSNavbar.Brand>

        <BSNavbar.Toggle />

        <BSNavbar.Collapse>
          <Nav className="me-auto">
            <Nav.Link onClick={() => navigate('/client/dashboard')}>
              <i className="fas fa-tachometer-alt me-1"></i>Dashboard
            </Nav.Link>
          </Nav>

          <Nav className="align-items-center">
            {portalClient && (
              <Dropdown align="end">
                <Dropdown.Toggle variant="primary" className="border-0 d-flex align-items-center gap-2">
                  <i className="fas fa-user-circle fa-lg"></i>
                  <span className="d-none d-md-inline">{portalClient.full_name}</span>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Header>
                    <div><small className="text-muted">Email:</small> {portalClient.email}</div>
                    <div><small className="text-muted">Customer Code:</small> {portalClient.customer_code}</div>
                  </Dropdown.Header>
                  <Dropdown.Divider />
                  <Dropdown.Item onClick={() => navigate('/client/profile')}>
                    <i className="fas fa-user-edit me-2"></i>View / Edit Profile
                  </Dropdown.Item>
                  <Dropdown.Item onClick={() => navigate('/client/change-password')}>
                    <i className="fas fa-key me-2"></i>Change Password
                  </Dropdown.Item>
                  <Dropdown.Divider />
                  <Dropdown.Item onClick={handleLogout} className="text-danger">
                    <i className="fas fa-sign-out-alt me-2"></i>Logout
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            )}
          </Nav>
        </BSNavbar.Collapse>
      </Container>
    </BSNavbar>
  );
};

export default ClientNavbar;
